<template> 
    <div class="card-carousel" @mouseover="stopTimer" @mouseleave="restartTimer">
        <div class="progressbar" v-if="autoSlideInterval && showProgressBar">
            <div :style="{width: progressBar + '%' }"></div>
        </div>
        <div class="card-img" v-for="(item,index) in items" :key="index" >
            <div class="carousel-item">
                <div class="folder">
                    <div class="folder-image" :style="{'background-image': 'url('+item.imagen+')'}"></div>
                        <div class="folder-info">
                            <h3 class="title-folder">{{item.nombre}}</h3>
                            <p class="folder-name"></p>
                        </div>
                    </div>
            </div>
        </div>
        <!--<div class="actions">
            <span @click="prev" class="prev">
                    
                        <font-awesome-icon icon="chevron-left" style="color:#00B99E"/>
                    
            </span>
            <span @click="next" class="next">
                    <font-awesome-icon icon="chevron-right" style="color:#00B99E"/>
            </span>
        </div> -->
        <!--<div class="thumbnails" style="overflow-y: scroll;">
                <div 
                    v-for="(item, index) in  items"
                    :key="index"
                    :class="['thumbnail-image', (activeItem == index) ? 'active' : '']"
                    @click="activateItem(index)"
                >
                    <img style="width:100px;height:100%" :src="getImage(item.data)">
                </div>
            </div>-->
    </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'

library.add(faChevronRight)
library.add(faChevronLeft)


export default {
    name: 'Carousel',
    components:{},
    data() {
        return {
            inicio:0,
            length:6,
            url : this.$store.getters.getMainUrl,
            // the active card
            currentItem:{},
            activeItem:0,
            //Hold the timeout, so we can clear it when it is needed
            autoSlideTimeout: null,
            //If the timer is stopped e.g. when hovering over the carousel
            stopSlider: false,
            //Hold the time left until changing to the next image
            timeLeft: 0,
            //Hold the interval so we can clear it when needed
            timerInterval: null,
            //Every 10ms decrease the timeLeft
            countdownInterval: 10
        }
    },
    mounted(){
      
    },
    computed: {
        // current gets called whenever activeItem changes
        // and is the reason why we don't have to worry about the 
        // big image getting updated
        current() {
            console.log('this carousel');
            if(this.items.length == 0) return {};
            else{
                this.activeItem = this.activeItem>=this.items.length? 0 : this.activeItem  ;
                this.timeLeft = this.autoSlideInterval;
                var currentItem = this.items[this.activeItem].data;
                console.log('currentItem');
                console.log(currentItem);
                return currentItem;
            }
        },
        progressBar() {
            //Calculate the width of the progressbar
            return 100 - (this.timeLeft/this.autoSlideInterval) * 100;
        }
    },
    methods: {
        // Go forward on the items array 
        // or go at the first image if you can't go forward
        next() {
            var active = this.activeItem + 1;
            console.log(active);
            if(active >= this.items.length) { //hacer llamada
                this.loadMoreItems(active);
            }else{
                this.activateItem(active);
            }
        },
        // Go backwards on the items array 
        // or go at the last image
        prev() {
            var active = this.activeItem - 1;
            if(active < 0) {
                active = this.items.length - 1;
            }
            this.activateItem(active);            
        },
        activateItem(itemIndex) {
            this.activeItem = itemIndex;
        },
        //Wait until 'interval' and go to the next image;
        startTimer(interval) {
            if(interval && interval > 0 && !this.stopSlider) {
                var self = this;
                clearTimeout(this.autoSlideTimeout);
                this.autoSlideTimeout = setTimeout(function() {
                    self.next();
                    self.startTimer(self.autoSlideInterval);
                }, interval);
            }
        },
        //Stop the timer when hovering over the carousel
        stopTimer() {
            clearTimeout(this.autoSlideTimeout);
            this.stopSlider = true;
            clearInterval(this.timerInterval);
        },
        //Restart the timer(with 'timeLeft') when leaving from the carousel
        restartTimer() {
            this.stopSlider = false;
            clearInterval(this.timerInterval);
            this.startCountdown();
            this.startTimer(this.timeLeft);
        },
        //Start countdown from 'autoSlideInterval' to 0
        startCountdown() {
            if(!this.showProgressBar) return;
            var self = this;
            this.timerInterval = setInterval(function() {
                self.timeLeft -= self.countdownInterval;
                if(self.timeLeft <= 0) {
                    self.timeLeft = self.autoSlideInterval;
                }
            }, this.countdownInterval);
        },
    },
    created() {
        //Check if startingImage prop was given and if the index is inside the items array bounds
        if(this.startingItem
            && this.startingItem >= 0
            && this.startingItem < this.items.length) {
            this.activeItem = this.startingItem;
        }
        //Check if autoSlideInterval prop was given and if it is a positive number
        if(this.autoSlideInterval
            && this.autoSlideInterval > this.countdownInterval) {
            //Start the timer to go to the next image
            this.startTimer(this.autoSlideInterval);
            this.timeLeft = this.autoSlideInterval;
            //Start countdown to show the progressbar
            this.startCountdown();
        }
    },
    props: ['startingItem', 'items', 'autoSlideInterval', 'showProgressBar','item']
}
</script>


<style scoped>
.card-carousel {
    user-select: none;
    position: relative;
    background: black; 
    max-height: 800px;
}

.progressbar {
    display: block;
    width: 100%;
    height: 5px;
    position: absolute;
    background-color: rgba(221, 221, 221, 0.25);
    z-index: 1;
}
.progressbar > div {
    background-color: rgba(255, 255, 255, 0.52);
    height: 100%;
}
.thumbnails {
    display:flex;
    height: 100px;
}
.thumbnail-image {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 2px;
}
.thumbnail-image > img {
    width: 100%;
    height: auto;
    transition: all 250ms;
}
.thumbnail-image:hover > img, 
.thumbnail-image.active > img,
.thumbnail-image.inactive > img,  {
    opacity: 1;
    box-shadow: 2px 2px 6px 1px rgba(0,0,0, 0.5);
}

.thumbnail-image.inactive > img {
    opacity: 0.5;

}
.card-img {
    position: relative;
    margin-bottom: 15px;
    width: 85%;
    margin: auto;
}
.card-img > img {
    display: block;
    margin: 0 auto;
}
.actions {
    font-size: 1.5em;
    height: 40px;
    position: absolute;
    margin-top: 8%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.actions > span {
    cursor: pointer;
    transition: all 250ms;
    font-size: 45px;
}
.actions > span.prev {
    margin-left: 0px;
}
.actions > span.next {
    margin-right: 0px;
}
.actions > span:hover {
    color: #eee;
}

.v-speed-dial {
    width: 60px;
    float:right
}

</style>